import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    businessProcesses: [],
    loaded: false
  }
};
const BusinessProcessesSlice = createSlice({
  name: "businessProcesses",
  initialState,
  reducers: {
    load: (state, action) => {
      state.value = {
        businessProcesses: action.payload,
        loaded: true
      };
    }
  }
});
export const { load } = BusinessProcessesSlice.actions;
export default BusinessProcessesSlice.reducer;
